import { ReactElement } from 'react';
import PropTypes from 'prop-types';
import PagingTable from '../../components/PagingTable';

/**
 * table to display and select users, specific to selecting delegatees
 * @param {string} props.name name to identify the component
 * @param {Object} props.formik formik context
 * @param {Object[]} props.directReports list of users
 * @returns {ReactElement} a component to select users
 */
const SelectDelegateeField = ({ name, formik, directReports }) => {
	const staff = [
		...directReports
			.filter(dr => dr.accountCategoryName === 'EMPLOYEE')
			.map(dr => ({
				...dr,
				isSelected: formik?.values[name]?.some(
					x => x?.fiId === dr?.fiId
				), //conditionally set this based on query params,
			})),
	];

	return (
		<PagingTable
			title='Select Delegatee'
			error={formik.errors[name]}
			initialValues={staff}
			onChange={value => {
				formik.setFieldTouched(name);
				formik.setFieldValue(
					name,
					value.filter(s => s.isSelected)
				);
			}}
			headCells={[
				{
					id: 'name',
					numeric: false,
					hasHeaderIcon: true,
					label: 'Name',
				},
				{
					id: 'jobTitle',
					numeric: false,
					hasHeaderIcon: false,
					label: 'Job Title',
				},
				{
					id: 'department',
					numeric: false,
					hasHeaderIcon: false,
					label: 'Department',
				},
			]}
			options={{
				enableSelectAll: false,
				enableCustomSelectAll: false,
				enableKeywordSearch: true,
				singleSelection: true,
			}}
			defaultOrderBy='name'
			defaultOrder='asc'
		/>
	);
};

SelectDelegateeField.propTypes = {
	name: PropTypes.string.isRequired,
	formik: PropTypes.object.isRequired,
	directReports: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default SelectDelegateeField;
